// noop - this is handled in app/utils/api
export const QueryClientProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}
